var map = {
	"./about-us.svg": 764,
	"./betting-icon.svg": 765,
	"./bonus.svg": 766,
	"./coin.png": 767,
	"./contact-us.svg": 768,
	"./download-app.svg": 769,
	"./edit-btn.svg": 770,
	"./feedback.svg": 771,
	"./global.svg": 772,
	"./info-centre.svg": 773,
	"./instant-rebate.svg": 774,
	"./mall-icon.svg": 775,
	"./message.svg": 776,
	"./redemption-icon.svg": 777,
	"./referral.svg": 778,
	"./resp-gaming.svg": 779,
	"./security.svg": 780,
	"./transaction-icon.svg": 781,
	"./vip-icon.svg": 782,
	"./wallet-icon.svg": 783
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 174;